module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "toc"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781454940760_epub_int_r1"
    }
  }, [_c('b', [_c('i', [_vm._v("Introduction")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781454940760_epub_ch1_r1"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('b', [_vm._v("CHAPTER 1")])]), _c('br'), _c('b', [_vm._v("Cooking with Cannabis: Kitchen Basics")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454940760_epub_ch2_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('b', [_vm._v("CHAPTER 2")])]), _c('br'), _c('b', [_vm._v("Morning Beverages and Light Meals")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454940760_epub_ch3_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('b', [_vm._v("CHAPTER 3")])]), _c('br'), _c('b', [_vm._v("Snacks")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454940760_epub_ch4_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('b', [_vm._v("CHAPTER 4")])]), _c('br'), _c('b', [_vm._v("Light Main Meals")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454940760_epub_ch5_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('b', [_vm._v("CHAPTER 5")])]), _c('br'), _c('b', [_vm._v("Desserts")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454940760_epub_ch6_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('b', [_vm._v("CHAPTER 6")])]), _c('br'), _c('b', [_vm._v("Drinks")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454940760_epub_apa_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('b', [_vm._v("APPENDIX A")])]), _c('br'), _c('b', [_vm._v("Cannabis Basics: Understanding the Human Endocannabinoid System")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454940760_epub_apb_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('b', [_vm._v("APPENDIX B")])]), _c('br'), _c('b', [_vm._v("Cannabis for Symptom Relief")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454940760_epub_aft_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('b', [_vm._v("AFTERWORD")])]), _c('br'), _c('b', [_vm._v("How Cannabis Raises Our Spirits")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454940760_epub_gls_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Glossary")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454940760_epub_ack_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454940760_epub_bib_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454940760_epub_res_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Resources")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454940760_epub_cre_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Photography Credits")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9781454940760_epub_ata_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("About the Author")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4949c9d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781454940760_epub_toc_r1.vue
// module id = 66
// module chunks = 0